import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {getDefaultLanguageStore, getLanguageCodes} from '../methods/helpers';

@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}

@Pipe({
  name: 'translate'
})
export class TranslationPipe implements PipeTransform {

  constructor() { }
  transform(text: string, dict: Record<string, string>) {
    const languageCodes = getLanguageCodes();
    if (languageCodes[text]) {
      return languageCodes[text];
    }
    if (!dict) {
      return text;
    }
    if (dict[text]) {
      return dict[text];
    }
    return getDefaultLanguageStore()[text] ?? text;
  }

}
